module.exports = __webpack_public_path__ + "img/restaurant.06b4f2d1.png";